import { useCallback, useState } from "react";
import { getApiErrorMessage } from "../../../../lib/result-codes";
import { restockMerchantCoupon as restockMerchantCouponApi } from "../api/merchantCouponList.api";

interface UseRestockMerchantCouponReturn {
  restockMerchantCoupon: (couponId: string, restockQuantity: number) => Promise<void>;
  loading: boolean;
  error: string | null;
}

export const useRestockMerchantCoupon = (): UseRestockMerchantCouponReturn => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const restockMerchantCoupon = useCallback(
    async (couponId: string, restockQuantity: number): Promise<void> => {
      try {
        setLoading(true);
        setError(null);
        await restockMerchantCouponApi(couponId, restockQuantity);
      } catch (restockError: unknown) {
        setError(getApiErrorMessage(restockError, "Failed to restock coupon"));
        throw restockError;
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  return { restockMerchantCoupon, loading, error };
};
